var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPennymacLoanServicesLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 249.6 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9c711;}.cls-2{fill:#00468b;}.cls-3{fill:#f9c606;}.cls-4{fill:#333;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 74.6,
    width: 246.2,
    height: 2.74
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M519.8,244.1a5,5,0,1,1-4.9-4.8A4.9,4.9,0,0,1,519.8,244.1Zm-8.7,0a3.8,3.8,0,0,0,3.8,3.9,3.7,3.7,0,0,0,3.7-3.8,3.8,3.8,0,0,0-3.8-4A3.8,3.8,0,0,0,511.1,244.1Zm3,2.6h-1.2v-4.9l1.9-.2a3.2,3.2,0,0,1,1.7.4,1.3,1.3,0,0,1,.5,1.1c0,.6-.5.9-1,1.1h0c.4.1.7.5.8,1.2a7.7,7.7,0,0,0,.4,1.2H516c-.2-.2-.2-.6-.4-1.2a.9.9,0,0,0-1-.8h-.5Zm0-2.8h.5c.6,0,1.2-.2,1.2-.7s-.4-.7-1.1-.7h-.6Z",
    transform: "translate(-270.2 -215)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.6,233.6c-3.2-2.9-8.1-4.3-14.5-4.3a80.3,80.3,0,0,0-12.4.9l-.8.2V281h8.3V261.4a28.8,28.8,0,0,0,4.2.2c6.7,0,12.3-2,15.8-5.7a15.6,15.6,0,0,0,4.1-11.2A14.3,14.3,0,0,0,303.6,233.6Zm-15.1,21a24.6,24.6,0,0,1-4.3-.3V236.6a31.5,31.5,0,0,1,5-.4c4,0,10.8,1.2,10.8,8.8S295.9,254.6,288.5,254.6Z",
    transform: "translate(-270.2 -215)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.2,249.8c-8.4,0-14.3,6.7-14.3,16.3s5.9,15.4,15,15.4a23.4,23.4,0,0,0,9.9-1.9l.6-.3-1.3-5.3-.8.4a19.1,19.1,0,0,1-7.7,1.4c-2.6,0-8.6-.8-9.1-8.4h20.1l.2-.9c0-.6.1-1.4.1-2.3C331.9,257.5,328.6,249.8,319.2,249.8Zm-.4,5.3a5.7,5.7,0,0,1,4.4,1.7,8.4,8.4,0,0,1,2.1,5.3H311.7C312.2,259.2,314.2,255.1,318.8,255.1Z",
    transform: "translate(-270.2 -215)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M349,249.8a11.6,11.6,0,0,0-9,4l-.2-3.3h-6.2v.8c.2,2.2.3,4.5.3,7.7v21.8h6.8V262.7a7.3,7.3,0,0,1,.3-2.2,6.5,6.5,0,0,1,6.3-4.8c4.8,0,5.9,4.2,5.9,7.7v17.4H360v-18C360,253.2,354.1,249.8,349,249.8Z",
    transform: "translate(-270.2 -215)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.1,249.8a11.6,11.6,0,0,0-9,4l-.2-3.3h-6.2v.8c.2,2.2.2,4.5.2,7.7v21.8h6.8V262.7a7.2,7.2,0,0,1,.4-2.2,6.5,6.5,0,0,1,6.3-4.8c4.8,0,5.8,4.2,5.8,7.7v17.4H390v-18C390,253.2,384.1,249.8,379.1,249.8Z",
    transform: "translate(-270.2 -215)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M411.2,250.5l-5.9,17.4c-.4,1.2-.8,2.6-1.1,3.7L403,268l-6.5-17.5h-7.4l11.1,27.6c0,.2.3.8.3,1.1s-.3.6-.4.9a14.8,14.8,0,0,1-4.2,5.6,12.8,12.8,0,0,1-4.3,2.4l-.7.2,1.7,5.8h.7a16,16,0,0,0,6.8-3.6c3.5-3,6-7.6,10.1-18.3l8.2-21.6Z",
    transform: "translate(-270.2 -215)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M449.5,239.1l-7.3,20c-1.6,4.4-2.7,7.9-3.6,11-.8-3.1-1.9-6.6-3.4-11l-7-20h-7.9l-2.9,41.7h6.5l1.1-17.9c.3-4.3.5-8.8.6-12.8.9,3.1,2,6.6,3.4,10.9l6.7,19.6h5l7.3-20c1.4-3.7,2.7-7.4,3.8-11,.1,4.2.3,8.9.5,12.9l1.1,18.3H460l-2.6-41.7Z",
    transform: "translate(-270.2 -215)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.4,273.2V262.4c0-8.3-4.1-12.6-11.7-12.6a18.5,18.5,0,0,0-9.9,2.7l-.5.3,1.7,5,.8-.6a14.3,14.3,0,0,1,7.1-2c3.8,0,5.7,1.9,5.8,5.7-6.8.1-11.7,1.6-14.5,4.5a9.3,9.3,0,0,0-2.9,7c0,4.5,3.3,9.1,9.6,9.1a11.5,11.5,0,0,0,8.4-3.4l.3,2.7H486v-.9A39,39,0,0,1,485.4,273.2Zm-6.6-7.1v4.3a3.9,3.9,0,0,1-.3,1.4,6.3,6.3,0,0,1-6.2,4.3c-2.6,0-4.2-1.6-4.2-4.3a4.9,4.9,0,0,1,1.3-3.3q2.6-2.4,9.3-2.4Z",
    transform: "translate(-270.2 -215)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M509.5,274.4a15.5,15.5,0,0,1-6.2,1.3c-5.5,0-9.2-4-9.2-10s3.7-10.1,9.4-10.1a11,11,0,0,1,5.7,1.3l.9.4,1.6-5.6-.6-.3a18.6,18.6,0,0,0-7.6-1.5c-9.6,0-16.3,6.6-16.3,16s6.1,15.6,15.2,15.6a19.4,19.4,0,0,0,8.6-1.8l.5-.3-1.2-5.4Z",
    transform: "translate(-270.2 -215)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.6,
    width: 7.6,
    height: 14.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M410.3,237.2,369.9,217c-3.1-1.3-7.7-1.5-10.7,0l-40.3,20.2c-7.1,3.5,3.8,8.6,10.7,5.2L364.4,225l35.1,17.4c7,3.5,17.6-1.8,10.8-5.2Z",
    transform: "translate(-270.2 -215)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M281.9,302v14.7H279V302Z",
    transform: "translate(-270.2 -215)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.3,302v14.7h-2.2l-6.3-9v9h-2.9V302h2.2l6.3,9v-9Z",
    transform: "translate(-270.2 -215)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299.9,313.4l2.5-1.5a3.3,3.3,0,0,0,3.4,2.3c1.7,0,2.4-.7,2.4-1.6s-1-1.5-3.2-2.1-4.5-1.6-4.5-4.4,2.4-4.4,4.9-4.4a5.6,5.6,0,0,1,5.2,3.3l-2.4,1.4a2.9,2.9,0,0,0-2.8-1.9c-1.2,0-2,.7-2,1.5s.6,1.4,2.8,2.1,4.9,1.5,4.9,4.5-2.3,4.4-5.4,4.4S300.7,315.6,299.9,313.4Z",
    transform: "translate(-270.2 -215)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.1,311.9V302H317v9.7c0,1.4.7,2.5,2.7,2.5s2.7-1.1,2.7-2.5V302h2.9v9.9c0,3.2-2.4,5.1-5.6,5.1S314.1,315.1,314.1,311.9Z",
    transform: "translate(-270.2 -215)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M334.3,311.6h-2.2v5.1h-2.9V302h5.9a4.8,4.8,0,0,1,2,9.2l3.3,5.5h-3.1Zm-2.2-2.5h3a2.2,2.2,0,0,0,0-4.4h-3Z",
    transform: "translate(-270.2 -215)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.9,314.1h-5.8l-.9,2.6h-3.1l5.1-14.7h3.6l5.2,14.7h-3.2Zm-.9-2.7-2-6-2,6Z",
    transform: "translate(-270.2 -215)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M370.1,302v14.7h-2.2l-6.3-9v9h-2.9V302h2.2l6.3,9v-9Z",
    transform: "translate(-270.2 -215)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M373,309.4a7.6,7.6,0,0,1,14-4.2l-2.5,1.4a4.3,4.3,0,0,0-3.9-2.1,4.9,4.9,0,0,0,0,9.7,4.3,4.3,0,0,0,3.9-2.1l2.5,1.5a7.3,7.3,0,0,1-6.4,3.4A7.4,7.4,0,0,1,373,309.4Z",
    transform: "translate(-270.2 -215)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M398.7,314v2.7h-9.1V302h9v2.8h-6.1v3.1h5.6v2.8h-5.6V314Z",
    transform: "translate(-270.2 -215)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.2,313.4l2.5-1.5a3.2,3.2,0,0,0,3.4,2.3c1.7,0,2.3-.7,2.3-1.6s-1-1.5-3.2-2.1-4.4-1.6-4.4-4.4,2.3-4.4,4.8-4.4a5.8,5.8,0,0,1,5.3,3.3l-2.5,1.4a2.9,2.9,0,0,0-2.8-1.9c-1.2,0-1.9.7-1.9,1.5s.6,1.4,2.8,2.1,4.8,1.5,4.8,4.5-2.2,4.4-5.3,4.4S409,315.6,408.2,313.4Z",
    transform: "translate(-270.2 -215)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M431.5,314v2.7h-9.1V302h9v2.8h-6.1v3.1h5.5v2.8h-5.5V314Z",
    transform: "translate(-270.2 -215)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M439.9,311.6h-2.2v5.1h-2.9V302h5.8a4.8,4.8,0,0,1,2.1,9.2l3.3,5.5h-3.2Zm-2.2-2.5h2.9a2.2,2.2,0,0,0,0-4.4h-2.9Z",
    transform: "translate(-270.2 -215)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M447.4,302h3.1l3.6,11.3,3.6-11.3h3.2l-5,14.7h-3.6Z",
    transform: "translate(-270.2 -215)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M466.5,302v14.7h-2.9V302Z",
    transform: "translate(-270.2 -215)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M469.4,309.4a7.5,7.5,0,0,1,7.6-7.7,7.2,7.2,0,0,1,6.3,3.5l-2.5,1.4a4.2,4.2,0,0,0-3.8-2.1,4.9,4.9,0,0,0,0,9.7,4.1,4.1,0,0,0,3.8-2.1l2.5,1.5A7.1,7.1,0,0,1,477,317,7.4,7.4,0,0,1,469.4,309.4Z",
    transform: "translate(-270.2 -215)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M495.5,314v2.7h-9.1V302h9v2.8h-6.1v3.1h5.6v2.8h-5.6V314Z",
    transform: "translate(-270.2 -215)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M498,313.4l2.5-1.5a3.3,3.3,0,0,0,3.4,2.3c1.8,0,2.4-.7,2.4-1.6s-1-1.5-3.2-2.1-4.4-1.6-4.4-4.4,2.3-4.4,4.8-4.4a5.5,5.5,0,0,1,5.2,3.3l-2.4,1.4a2.9,2.9,0,0,0-2.8-1.9c-1.2,0-1.9.7-1.9,1.5s.5,1.4,2.8,2.1,4.8,1.5,4.8,4.5-2.2,4.4-5.4,4.4S498.8,315.6,498,313.4Z",
    transform: "translate(-270.2 -215)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPennymacLoanServicesLogo);
export default __webpack_public_path__ + "static/media/pennymac-loan-services-logo.80c36f410dce6d735e4d258dcc1f29db.svg";
export { ForwardRef as ReactComponent };